import { Type } from '@sinclair/typebox';
import { ConditionBuilderSchema } from "./condition.mjs";
export const ConstraintResponseSchema = Type.Object({
    id: Type.Number(),
    attributeId: Type.Number(),
    attributeName: Type.String(),
    collectionId: Type.Number(),
    conditions: Type.Record(Type.String(), ConditionBuilderSchema),
    versionId: Type.Number(),
});
export const CreateConstraintSchema = Type.Omit(ConstraintResponseSchema, ['id', 'attributeName']);
export const UpdateConstraintSchema = Type.Partial(Type.Omit(CreateConstraintSchema, ['versionId']));
//# sourceMappingURL=constraints.js.map